//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ValidateCode from '@/components/validate-code'
  export default {
    name: "send-email",
    components:{ValidateCode},
    data(){
      var validatePass2 = (rule, value, callback) => {
        let regExp = /^[\u4e00-\u9fa5]+$/;
        if (regExp.test(value)) {
          callback(new Error('请输入非中文字符'));
        } else {
          callback();
        }
      };
      return{
        verifyForm:{
          supplierName: '',
          imageCode:'',
          email:'',
          phone:''
        },
        verifyRules:{
          supplierName:[
            { required: true, message: '此字段必填', trigger: ['blur', 'change'] }
          ],
          phone:[
            { required: true, message: '此字段必填', trigger: ['blur', 'change'] },
          ],
          email:[
            { required: true, message: '此字段必填', trigger: ['blur', 'change'] },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
          ],
          imageCode:[
            { required: true, message: '此字段必填', trigger: ['blur', 'change'] },
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
      }
    },
    methods:{
      sendEmail(){
        this.$refs['verifyForm'].validate((valid) => {
          if(valid){
            this.$loadingShow();
            this.$post('api/before-login/resend?_allow_anonymous=true',this.verifyForm).then((data) => {
              this.$loadingHide();
              if(data.status === 'error') {
                if(data.msg === 'VALIDATE_CODE_EXPIRED'){
                  this.$vux.toast.text('验证码已过期，请重新输入');
                }else{
                  this.$vux.toast.text('验证码错误，请重新输入');
                }
                this.$refs.imgCode.getImage();
                return;
              }
              this.$vux.toast.text('发送邮件成功');
              this.$emit('sendMsg',this.verifyForm.email,this.verifyForm.supplierName);
            }).catch(() => {
              this.$loadingHide();
            })
          }
        })
      },
      refreshImageCode(){
        this.$refs.imgCode.getImage();
      }
    }
  }



// WEBPACK FOOTER //
// ./src/page/supplier/register/send-email.vue